function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useContext, useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { twMerge } from "@stereoagency/tailwind-config";
import NavBarHeader from "./NavBarHeader";
import { fadeIn, fadeInHeight } from "../../motion/variants";
import { slowSpring } from "../../motion/transitions";
import { ArrowDown, Search } from "../../visuals";
import { NavigationItem } from "../../molecules";
import { CallToAction } from "../../atoms";
import ReactConfigContext from "../../ReactConfigContext";
export default function MobileMenuOverlay(param) {
    var open = param.open, items = param.items, action = param.action, searchAction = param.searchAction, homepageAction = param.homepageAction, metaItems = param.metaItems, languageOptions = param.languageOptions, onToggle = param.onToggle;
    var _languageOptions_options;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    var _useState = _sliced_to_array(useState(false), 2), languageOpen = _useState[0], setLanguageOpen = _useState[1];
    var handleToggleLanguageSwitch = function() {
        setLanguageOpen(!languageOpen);
    };
    useEffect(function() {
        if (open) {
            var handler = function(event) {
                if (event.key === "Escape") {
                    onToggle === null || onToggle === void 0 ? void 0 : onToggle();
                }
            };
            window.addEventListener("keyup", handler);
            document.body.classList.add("overflow-hidden");
            return function() {
                window.removeEventListener("keyup", handler);
                document.body.classList.remove("overflow-hidden");
            };
        }
        return function() {};
    }, [
        open
    ]);
    return /*#__PURE__*/ React.createElement(AnimatePresence, null, open && /*#__PURE__*/ React.createElement(motion.div, {
        key: "background",
        variants: fadeIn,
        initial: "hide",
        exit: "hide",
        animate: "show",
        transition: slowSpring,
        className: twMerge("fixed top-0 left-0 w-full h-full bg-blue-500 text-fg-inverted z-10", "grid grid-cols-1 grid-rows-[auto_1fr]")
    }, /*#__PURE__*/ React.createElement(NavBarHeader, {
        className: "w-full",
        homepageAction: homepageAction,
        searchAction: searchAction,
        menuOpen: open,
        menuItems: [],
        onToggle: onToggle
    }), /*#__PURE__*/ React.createElement("div", {
        className: "min-h-full overflow-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "min-h-full grid grid-cols-1 grid-rows-1 pt-5 px-6 pb-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-9 grid-cols-1 grid-rows-[auto_minmax(0px,1fr)_auto_auto] justify-items-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-between"
    }, !!searchAction && /*#__PURE__*/ React.createElement(LinkComponent, searchAction, /*#__PURE__*/ React.createElement(Search, null)), languageOptions && /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "flex items-center font-heading font-semibold text-navigation-base uppercase",
        onClick: handleToggleLanguageSwitch
    }, /*#__PURE__*/ React.createElement("span", null, languageOptions.active.label), /*#__PURE__*/ React.createElement(motion.span, {
        animate: {
            rotate: languageOpen ? 180 : 0
        },
        transition: slowSpring,
        className: "ml-3"
    }, /*#__PURE__*/ React.createElement(ArrowDown, null)))), /*#__PURE__*/ React.createElement(AnimatePresence, null, !!languageOpen && /*#__PURE__*/ React.createElement(motion.div, {
        variants: fadeInHeight,
        initial: "hide",
        exit: "hide",
        animate: "show",
        className: "overflow-hidden -mx-6",
        transition: slowSpring
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-bg-subtle/10 py-6 mt-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-4"
    }, languageOptions === null || languageOptions === void 0 ? void 0 : (_languageOptions_options = languageOptions.options) === null || _languageOptions_options === void 0 ? void 0 : _languageOptions_options.map(function(opt) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "opt-".concat(opt.label),
            className: "font-heading text-navigation-base font-semibold uppercase px-6"
        }, opt.href ? /*#__PURE__*/ React.createElement(LinkComponent, {
            href: opt.href
        }, opt.label) : /*#__PURE__*/ React.createElement("button", {
            type: "button",
            onClick: opt.onClick
        }, opt.label));
    })))))), /*#__PURE__*/ React.createElement("div", {
        className: "my-auto grid grid-cols-1 grid-flow-row auto-rows-max gap-6 justify-items-center"
    }, items.map(function(item) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "item-".concat(item.action.href)
        }, /*#__PURE__*/ React.createElement(NavigationItem, item));
    })), !!action && /*#__PURE__*/ React.createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto flex flex-col w-full max-w-[18.125rem]"
    }, /*#__PURE__*/ React.createElement(CallToAction, action))), !!(metaItems === null || metaItems === void 0 ? void 0 : metaItems.length) && /*#__PURE__*/ React.createElement("div", {
        className: "grid text-center grid-cols-1 grid-flow-row auto-rows-max gap-6 justify-items-center"
    }, metaItems.map(function(item) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "meta-item-".concat(item.href),
            className: "leading-tight"
        }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, item), {
            className: twMerge("font-heading font-semibold text-navigation-small opacity-60 uppercase", item.className)
        })));
    })))))));
}

//# sourceMappingURL=MobileMenuOverlay.js.map